import { AccessClient } from "./axiosInstance.js";

/**
 * 새로운 계정 등록하기
 */
export const registerAccout = async ({
  displayName,
  username,
  password,
  password2,
  roles, // 역활이 배열
  dsUnivLink,
}) => {
  let body = {
    displayName,
    username,
    password,
    password2,
    roles,
    dsUnivLink, // 학사 시스템 연동
  };

  try {
    const response = await AccessClient.post("/api/register", body);
    console.log("response : ", response);
    const {
      status,
      data: { message },
    } = response;
    return { status, message };
  } catch (error) {
    //    console.log(error.response);

    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};


